import en_US from '../../date-picker/locale/en_US';
export default en_US;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/calendar/locale/en_US.js
// module id = 302
// module chunks = 0